import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility';

const initialState = {
    data: null,
    count: null,
    projectId: null,
    pageS:null,
    msg: null,
    loading: null,
    error: null,
  };

  const selectProjectId = (state, action) => {
    return updateObject(state, { projectId: action.projectId });
  };
  const clearProjectId = (state, action) => {
    return updateObject(state, { projectId: null, data: null });
  };

  const fetchClientProjectPeriodStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
  };

  const fetchClientProjectPeriodSuccess = (state, action) => {
    return updateObject(state, {
      count: action.count,
      data: action.data,
      error: null,
      loading: false,
    });
  };

  const fetchClientProjectPeriodFail = (state, action) => {
    return updateObject(state, {
      error: action.error,
      loading: false,
    });
  };

  // for create traker


    const createClientProjectPeriodStart = (state, action) => {
    return updateObject(state, { msg: null, error: null, loading: true });
    };

  const createClientProjectPeriodSuccess = (state, action) => {
    let newArr = null;
  if (state.pageS === state.data.length) {
    let oldArr = [...state.data];
    oldArr.pop();
    oldArr.unshift(action.newPeriod);
    newArr = [...oldArr];
  } else {
    let oldArr = [...state.data];
    oldArr.unshift(action.newPeriod);
    newArr = [...oldArr];
  }
    return updateObject(state, {
      data: newArr,
      count: state.count +1 ,
      msg: action.msg,
      error: null,
      loading: false,
    });
  };

  const createClientProjectPeriodFail = (state, action) => {
    return updateObject(state, {
      error: action.error,
      loading: false,
      msg: null,
    });
  };


  const reducer = (state = initialState, action) => {
      switch(action.type){
          case actionTypes.SELECT_PROJECT_ID:
            return selectProjectId(state, action);
          case actionTypes.CLEAR_PROJECT_ID:
            return clearProjectId(state, action);
          case actionTypes.FETCH_CLIENT_PROJECT_PERIOD_START:
            return fetchClientProjectPeriodStart(state, action);
          case actionTypes.FETCH_CLIENT_PROJECT_PERIOD_SUCCESS:
            return fetchClientProjectPeriodSuccess(state, action);
          case actionTypes.FETCH_CLIENT_PROJECT_PERIOD_FAIL:
            return fetchClientProjectPeriodFail(state, action);
          case actionTypes.CREATE_CLIENT_PROJECT_PERIOD_START:
            return createClientProjectPeriodStart(state,action);
          case actionTypes.CREATE_CLIENT_PROJECT_PERIOD_SUCCESS:
            return createClientProjectPeriodSuccess(state,action);
          case actionTypes.CREATE_CLIENT_PROJECT_PERIOD_FAIL:
            return createClientProjectPeriodFail(state,action);
          default:
            return state;
      }
    
  }

  export default reducer;